<template lang="pug">
v-card
  v-card-title
    h4 {{ $t('widgets.answerMemo.title') }}
    v-spacer
    template(v-if="editable")
      .text-xs-right(v-if="localEditMode")
        v-btn(v-show="!loading" color="accent" small flat @click="cancel")
          | {{ $t('text.cancel') }}
        v-btn(color="accent" small flat :loading="loading" @click="onSubmit")
          | {{ $t('text.save') }}
      btn-icon(
        v-else
        icon="edit"
        color="accent"
        :tooltip="$t('text.edit')"
        flat
        @click="localEditMode = !localEditMode")
  v-card-text.memoBody.pa-2
    answer-memo-field(v-if="localEditMode" v-model="localValue" solo :disabled="loading")
    p(v-else) {{ value }}
</template>

<script>
import AnswerMemoField from '@/components/form/AnswerMemoField'
import BtnIcon from '@/components/button/BtnIcon'

export default {
  components: {
    AnswerMemoField,
    BtnIcon,
  },
  props: {
    value: String,
    loading: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    originalValue: "",
  }),
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    localEditMode: {
      get () {
        return this.editMode
      },
      set (value) {
        this.$emit('update:editMode', value)
      }
    }
  },
  watch: {
    localEditMode (v) {
      if (v) {
        this.originalValue = this.value
      }
    }
  },
  methods: {
    cancel () {
      this.localEditMode = false
      this.localValue = this.originalValue
    },
    onSubmit () {
      this.$emit("submit", this.localValue)
    }
  }
}
</script>

<style lang="styl" scoped>
.memoBody
  > p
    white-space pre-wrap
    overflow-y scroll
</style>
